import Button from '@/components/base/Button';

export default function ProductsSection() {
  const productCategories = [
    {
      title: '云服务器产品',
      icon: 'ri-server-line',
      color: 'bg-blue-500'
    },
    {
      title: '开发者工具与服务',
      icon: 'ri-code-s-slash-line',
      color: 'bg-green-500'
    },
    {
      title: '数据智能',
      icon: 'ri-database-2-line',
      color: 'bg-purple-500'
    }
  ];

  const products = [
    {
      category: '云服务器产品',
      name: '通用型云服务器',
      description: '适用于中小型Web应用、轻量级应用和开发测试',
      features: ['2-32核CPU', '4-128GB内存', '高性能SSD', '弹性公网IP'],
      icon: 'ri-server-line',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      category: '开发者工具与服务',
      name: '容器服务',
      description: '基于Kubernetes的容器管理服务，简化应用部署',
      features: ['一键部署', '自动扩缩容', '服务发现', '负载均衡'],
      icon: 'ri-code-box-line',
      gradient: 'from-emerald-500 to-teal-500'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">产品矩阵</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            全面的ARM云产品矩阵，满足从基础设施到上层应用的各种需求
          </p>
        </div>

        {/* Product Categories */}
        <div className="flex justify-center mb-8 sm:mb-12">
          <div className="flex bg-gray-100 rounded-full p-1 overflow-x-auto max-w-full">
            {productCategories.map((category, index) => (
              <button
                key={index}
                className={`px-4 sm:px-6 py-2.5 sm:py-3 rounded-full text-xs sm:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer flex-shrink-0 ${
                  index === 0 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <i className={`${category.icon} mr-1.5 sm:mr-2`}></i>
                {category.title}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 mb-10 sm:mb-12 lg:mb-16">
          {products.map((product, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-5 sm:p-6 lg:p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
                {/* Product Icon */}
                <div className="sm:w-1/3 lg:w-1/3">
                  <div className={`w-full h-36 sm:h-40 lg:h-32 rounded-xl bg-gradient-to-br ${product.gradient} flex items-center justify-center`}>
                    <i className={`${product.icon} text-5xl sm:text-6xl text-white/90`}></i>
                  </div>
                </div>
                
                {/* Product Info */}
                <div className="sm:w-2/3 lg:w-2/3">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">{product.description}</p>
                  
                  <div className="grid grid-cols-2 gap-2 mb-3 sm:mb-4">
                    {product.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center text-xs sm:text-sm text-gray-700">
                        <i className="ri-check-line text-green-500 mr-1.5 sm:mr-2"></i>
                        {feature}
                      </div>
                    ))}
                  </div>
                  
                  <Button variant="outline" size="sm" className="border-blue-600 text-blue-600 hover:bg-blue-50">
                    了解详情
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* All Products CTA */}
        <div className="text-center bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 sm:p-10 lg:p-12 text-white">
          <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">探索更多产品</h3>
          <p className="text-sm sm:text-base text-blue-100 mb-5 sm:mb-6 max-w-2xl mx-auto">
            我们提供完整的ARM云产品生态，从基础计算到AI加速，满足您的所有云计算需求
          </p>
          <Button variant="secondary" size="lg" className="bg-white text-blue-600 hover:bg-gray-100 w-full sm:w-auto">
            查看全部产品
          </Button>
        </div>
      </div>
    </section>
  );
}
